import React, { useState, useRef, useEffect } from 'react';
import './CreateItemDialog.css';

const CreateItemDialog = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  fields, // Array of field objects: { name, placeholder, rules, maxLength }
  currentStep = 0
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen, currentStep]);

  useEffect(() => {
    if (isOpen) {
      // Set default values, especially for shot increment
      const defaultValues = {};
      if (fields && fields[currentStep]) {
        const currentField = fields[currentStep];
        if (currentField.name === 'shotIncrement') {
          defaultValues[currentField.name] = '10';
        }
      }
      setValues(defaultValues);
      setErrors({});
    }
  }, [isOpen, currentStep, fields]);

  const handleInputChange = (fieldName, value) => {
    setValues(prev => ({ ...prev, [fieldName]: value }));
    if (errors[fieldName]) {
      setErrors(prev => ({ ...prev, [fieldName]: false }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const currentField = fields[currentStep];
    const value = values[currentField.name] || '';
    
    if (!value.trim()) {
      setErrors(prev => ({ ...prev, [currentField.name]: 'This field is required' }));
      return;
    }

    onSubmit(value, currentField.name);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit(e);
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  const currentField = fields[currentStep];
  const currentValue = values[currentField.name] || '';

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>{title}</h3>
          <button className="dialog-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="dialog-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{currentField.placeholder}</label>
              <input
                ref={inputRef}
                type="text"
                value={currentValue}
                onChange={(e) => handleInputChange(currentField.name, e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={currentField.placeholder}
                maxLength={currentField.maxLength}
                className={errors[currentField.name] ? 'error' : ''}
              />
              {errors[currentField.name] && (
                <span className="error-message">{errors[currentField.name]}</span>
              )}
            </div>
            
            {currentField.rules && (
              <div className="format-rules">
                <h4>Format Requirements:</h4>
                <ul>
                  {currentField.rules.map((rule, index) => (
                    <li key={index}>{rule}</li>
                  ))}
                </ul>
              </div>
            )}
            
            <div className="dialog-buttons">
              <button type="button" onClick={onClose} className="btn-cancel">
                Cancel
              </button>
              <button type="submit" className="btn-confirm">
                {currentStep < fields.length - 1 ? 'Next' : 'Create'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateItemDialog;